import { MyConversationsInboxType } from '@kamernet/core/ApiClient/Kamernet';

import { AnalyticsPageName } from '../types';

const INBOX_TYPE_TO_PAGE_NAME: Record<
  MyConversationsInboxType,
  AnalyticsPageName
> = {
  [MyConversationsInboxType.Default]: AnalyticsPageName.MyConversationsAll,
  [MyConversationsInboxType.All]: AnalyticsPageName.MyConversationsAll,
  [MyConversationsInboxType.Unreplied]:
    AnalyticsPageName.MyConversationsUnreplied,
  [MyConversationsInboxType.Favorite]:
    AnalyticsPageName.MyConversationsFavorite,
  [MyConversationsInboxType.ActiveListings]:
    AnalyticsPageName.MyConversationsActiveListings,
  [MyConversationsInboxType.InactiveListings]:
    AnalyticsPageName.MyConversationsInactiveListings,
  [MyConversationsInboxType.Trash]: AnalyticsPageName.MyConversationsTrash,
};

export function getConversationsInboxPageName(
  inboxType: MyConversationsInboxType,
): AnalyticsPageName {
  return INBOX_TYPE_TO_PAGE_NAME[inboxType];
}
